import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import { Col, Row, Input, Button, InputGroup, Label } from "reactstrap";
import { Redirect, useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarAlt,
	faInfo,
	faPaperclip,
	faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../../../components/Header";
import { UserConsumer } from "../../../UserContext";
import { ViewEmployees_API } from "./ViewEmployees_API";
import { AlertPopups } from "../../../components/AlertPopups";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { Config, Routes } from "../../../configurations/config";
import {
	SET_NAVBAR_ITEMS,
	SET_NAVBAR_TAB,
} from "../../../components/navbarRedux/types";
import moment from "moment";
import ImagePreviewer from "../../../components/ImagePreviewer";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

function AddEmployee() {
	let token = null;
	const dispatch = useDispatch();
	const history = useHistory();
	const DatepickerRef = useRef(null);
	const [employeeInfo, setEmployeeInfo] = useState({
		employeeCode: "",
		employeeName: "",
		empYearsExperience: "",
		empJoinedOn: "",
		empRemarks: "",
		employeeLogin: "",
		empEmerContactAdd: "",
		empEmerContactName: "",
		empEmerContactPhone1: "",
		empEmerContactPhone2: "",
		annualLeave: 0,
		sickLeave: 0,
	});

	const developmentCenter = [
		{ value: 1, label: "DC-1" },
		{ value: 2, label: "DC-2" },
	];
	const [selectedDevelopmentCenter, setSelectedDevelopmentCenter] =
		useState(null);
	const [departmentList, setDepartmentList] = useState([]);
	const [selectedDepartment, setSelectedDepartment] = useState(null);
	const [supervisorList, setSupervisorList] = useState([]);
	const [selectedSupervisor, setSelectedSupervisor] = useState(null);
	const [designtaionList, setDesignationList] = useState(null);
	const [selectedDesignation, setSelectedDesignation] = useState(null);
	const [systemRoleList, setSystemRoleList] = useState([]);
	const [selectedSystemRole, setSelectedSystemRole] = useState(null);
	const [statusList, setStatusList] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [handleResetButton, setHandleReset] = useState(false);
	const [attachedFileName, setAttachedFileName] = useState("");
	const [attachment, setAttachment] = useState("");
	const [fileErr, setFileErr] = useState(false);
	const [fileSizeErr, setFileSizeErr] = useState(false);

	const openDatepicker = () => {
		const datepickerElement = DatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	useEffect(() => {
		if (!handleResetButton) {
			//call API when employee Info is changed
			const header = { Authorization: `Bearer ${token}` };
			axios
				.get(`${ViewEmployees_API.GetDepartmentList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setDepartmentList(
							data.departments.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
			axios
				.get(`${ViewEmployees_API.GetSupervisorList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						//converting api data according to react select value,label pair
						const allSupervisors = data.map((item) => {
							return {
								value: item.employeeId,
								label: item.name,
							};
						});
						allSupervisors.sort((a, b) =>
							a.label.localeCompare(b.label)
						);
						setSupervisorList(allSupervisors);
					}
				});
			axios
				.get(`${ViewEmployees_API.GetDesignationList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setDesignationList(
							data.designations.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
			axios
				.get(`${ViewEmployees_API.GetSystemRolesList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setSystemRoleList(
							data.systemRoles.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
			axios
				.get(`${ViewEmployees_API.GetEmployeeStatusList}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setStatusList(
							data.statuses.sort((a, b) =>
								a.label.localeCompare(b.label)
							)
						);
					}
				});
		}
	}, [employeeInfo]);
	const handleChange = (temp, displayCode, e) => {
		//Function to handle Input Change
		if (displayCode === 2) {
			//datePicker
			setEmployeeInfo({
				...employeeInfo,
				["empJoinedOn"]: temp,
			});
		} else {
			//Input fields
			const { name, value } = temp.target;
			setEmployeeInfo({
				...employeeInfo,
				[name]: value,
			});
		}
	};
	function dataURLtoFile(dataurl) {
		let filename = employeeInfo.employeeName + ".png";
		let arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new File([u8arr], filename, { type: mime });
	}
	const prepareFormData = () => {
		let formdata = new FormData();
		formdata.append("EmployeeCode", employeeInfo.employeeCode);
		formdata.append("EmployeeName", employeeInfo.employeeName);
		formdata.append(
			"empDepartment",
			selectedDepartment ? selectedDepartment.value : null
		);
		formdata.append(
			"empDesignation",
			selectedDesignation ? selectedDesignation.value : null
		);
		formdata.append(
			"empSupervisorName",
			selectedSupervisor ? selectedSupervisor.value : null
		);
		formdata.append(
			"empRole",
			selectedSystemRole ? selectedSystemRole.value : null
		);
		formdata.append(
			"empStatus",
			selectedStatus ? selectedStatus.value : null
		);
		formdata.append(
			"EmpDevelopmentCenter",
			selectedDevelopmentCenter ? selectedDevelopmentCenter.value : null
		);
		formdata.append("empRemarks", employeeInfo.empRemarks);
		formdata.append("empYearsExperience", employeeInfo.empYearsExperience);
		formdata.append("employeeLogin", employeeInfo.employeeLogin);
		if (employeeInfo.empJoinedOn)
			formdata.append(
				"empJoinedOn",
				moment(employeeInfo?.empJoinedOn).format(APIDateFormat)
			);
		formdata.append("empEmerContactAdd", employeeInfo.empEmerContactAdd);
		formdata.append("empEmerContactName", employeeInfo.empEmerContactName);
		formdata.append(
			"empEmerContactPhone1",
			employeeInfo.empEmerContactPhone1
		);
		formdata.append(
			"empEmerContactPhone2",
			employeeInfo.empEmerContactPhone2
		);
		formdata.append("annualLeave", employeeInfo.annualLeave);
		formdata.append("sickLeave", employeeInfo.sickLeave);

		if (attachment !== null && attachment != "") {
			formdata.append("employeeImage", dataURLtoFile(attachment));
		}

		return formdata;
	};
	const handleSuccess = () => {
		AlertPopups.successAlert.fire({ text: "Employee Added" });
		dispatch({ type: SET_NAVBAR_TAB, payload: "AdminTasks" });
		dispatch({ type: SET_NAVBAR_ITEMS, payload: "ViewEmployees" });
		sessionStorage.setItem("NavbarTab", "AdminTasks");
		sessionStorage.setItem("NavbarItem", "ViewEmployees");
		history.push(Routes.ViewEmployees);
	};

	const handleError = (error) => {
		if (error.response) {
			if (employeeInfo.employeeLogin === "") {
				AlertPopups.ErrorAlert.fire({
					text: "Please Enter Employee Login",
				});
			} else {
				AlertPopups.ErrorAlert.fire({
					text: error.response.data.message,
				});
			}
		}
	};
	const handleSubmit = (e) => {
		e.preventDefault(); //prevent page reload
		if (
			selectedDepartment === null ||
			selectedDesignation === null ||
			selectedSupervisor === null ||
			selectedSystemRole === null ||
			selectedStatus === null ||
			selectedDevelopmentCenter === null
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Enter Required Fields",
			});
		} else {
			const formdata = prepareFormData();

			if (!fileErr && !fileSizeErr)
				axios
					.post(`${ViewEmployees_API.AddEmployee}`, formdata, {
						headers: { Authorization: `Bearer ${token}` },
					})
					.then(({ status }) => {
						if (status === 200) {
							handleSuccess();
						} else {
							AlertPopups.ErrorAlert.fire({
								text: "Add Employee Error",
							});
						}
					})
					.catch(handleError);
		}
	};
	const handleReset = () => {
		//Function to handle Reset Button
		setHandleReset(true);
		setEmployeeInfo({
			employeeCode: "",
			employeeName: "",
			empYearsExperience: "",
			empJoinedOn: "",
			empRemarks: "",
			employeeLogin: "",
			empEmerContactAdd: "",
			empEmerContactName: "",
			empEmerContactPhone1: "",
			empEmerContactPhone2: "",
			annualLeave: "",
			sickLeave: "",
		});
		setSelectedSupervisor(null);
		setSelectedDepartment(null);
		setSelectedDevelopmentCenter(null);
		setSelectedSystemRole(null);
		setSelectedStatus(null);
		setSelectedDesignation(null);
	};
	const formatBytes = (a) => {
		let units = ["B", "KB", "MB", "GB", "TB"],
			bytes = a,
			i;

		for (i = 0; bytes >= 1024 && i < 4; i++) {
			bytes /= 1024;
		}

		return { size: bytes.toFixed(2), units: units[i] };
	};
	const handleAddAttachement = (temp) => {
		if (temp.target.files[0] !== undefined) {
			setFileErr(false);
			setFileSizeErr(false);

			let totalBytes = temp.target.files[0].size;
			let fileInfo = formatBytes(totalBytes);
			if (fileInfo.units === "MB")
				if (parseInt(fileInfo.size) > 1) setFileSizeErr(true);

			if (["image/png"].includes(temp.target.files[0].type)) {
				const reader = new FileReader();
				let img = "";

				if (reader.result)
					reader.addEventListener("load", () => {
						const uploaded_image = reader.result;
						img =
							document.getElementsByClassName("profileThumnail");
						img.src = uploaded_image;
					});
				else {
					let reader2 = new FileReader();

					reader2.onload = function (e) {
						const uploaded_image = reader2.result;
						img =
							document.getElementsByClassName("profileThumnail");
						img.src = uploaded_image;
						const img2 =
							document.getElementById(
								"imgPrview"
							).lastElementChild;
						img2.src = uploaded_image;
						setAttachment(uploaded_image);
					};

					reader2.readAsDataURL(temp.target.files[0]);
				}
			} else {
				setFileErr(true);
			}
		}
	};
	const handleRemoveAttachement = () => {
		document.getElementById("attachment").value = null;
		setFileErr(false);
		setFileSizeErr(false);
		setAttachment("");
		setAttachedFileName("");

		if (document.getElementById("icon")) {
			document.getElementById("icon").remove();
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") || //Authoring
					userDetails.designation.toString() === "4" ||
					userDetails.id.toString() === "180" ||
					userDetails.id.toString() === "269" ? ( //Authorized URL
					<>
						<div className="container-fluid pl-3 pr-3">
							{/* Page Header*/}
							<Header
								title="Add Employee"
								headerBorder="false"
								navigateBack={() =>
									history.push(Routes.ViewEmployees)
								}
							/>

							{employeeInfo && ( //Show form when Employee Info is loaded
								<form onSubmit={handleSubmit}>
									<>
										{/* Employee Information Form*/}
										<div className="formInfoContainer my-3">
											<div className="formInfoContainerHeader ">
												<Label sm={12}>
													Employee Information
												</Label>
											</div>
											<Col>
												<Row className="py-2 px-2">
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Employee Name
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="employeeName"
															value={
																employeeInfo.employeeName
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`formValueInput`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Employee Code
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="employeeCode"
															value={
																employeeInfo.employeeCode
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`formValueInput`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Department
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empDepartment"
															options={
																departmentList
															}
															value={
																selectedDepartment
															}
															onChange={(value) =>
																setSelectedDepartment(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Development
																Center
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empDevelopmentCenter"
															options={
																developmentCenter
															}
															value={
																selectedDevelopmentCenter
															}
															onChange={(value) =>
																setSelectedDevelopmentCenter(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																System Role
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empRole"
															options={
																systemRoleList
															}
															value={
																selectedSystemRole
															}
															onChange={(value) =>
																setSelectedSystemRole(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Supervisor Name
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empSupervisorName"
															options={
																supervisorList
															}
															value={
																selectedSupervisor
															}
															onChange={(value) =>
																setSelectedSupervisor(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Designation
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empDesignation"
															options={
																designtaionList
															}
															value={
																selectedDesignation
															}
															onChange={(value) =>
																setSelectedDesignation(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Experience (in
																Years)
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="number"
															name="empYearsExperience"
															value={
																employeeInfo.empYearsExperience
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox mt-2`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Joining Date
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1 datepicker-wrapper"
													>
														<InputGroup className="datepicker-wrapper">
															<DatePicker
																showYearDropdown
																showMonthDropdown
																dateFormatCalendar=" " //for title
																dateFormat="dd/MM/yyyy"
																name="empJoinedOn"
																className={`custom-container`}
																selected={
																	employeeInfo.empJoinedOn
																		? new Date(
																				employeeInfo.empJoinedOn
																		  )
																		: null
																}
																onChange={(
																	value,
																	event
																) =>
																	handleChange(
																		value,
																		2,
																		event
																	)
																}
																onChangeRaw={(
																	e
																) => {
																	e.preventDefault();
																}}
																autoComplete="off"
																ref={
																	DatepickerRef
																}
															/>

															<FontAwesomeIcon
																icon={
																	faCalendarAlt
																}
																className="calender-icon"
																color="keppel"
																onClick={() =>
																	openDatepicker()
																}
															/>
														</InputGroup>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Employee Status
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<CustomReactSelect
															name="empStatus"
															options={statusList}
															value={
																selectedStatus
															}
															onChange={(value) =>
																setSelectedStatus(
																	value
																)
															}
															className={`ml-0`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>Remarks</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="my-1"
													>
														<Input
															type="textarea"
															name="empRemarks"
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	4,
																	event
																)
															}
															value={
																employeeInfo.empRemarks
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Employee Login
																<span className="required">
																	*
																</span>
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="employeeLogin"
															value={
																employeeInfo.employeeLogin
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div className="d-flex">
																<span>
																	Profile
																	Image
																</span>
																<span
																	className="imp-info mt-1"
																	data-tip="tooltip"
																	data-for="imageInfo"
																>
																	<FontAwesomeIcon
																		icon={
																			faInfo
																		}
																		className="fas fa-info-circle infoExclamation-icon"
																	/>
																</span>
																<ReactTooltip
																	id="imageInfo"
																	className="ImageInfoToolTip"
																	place="bottom"
																	effect="solid"
																	variant="light"
																	positionStrategy="fixed"
																>
																	{"*Image size should be less than 1 MB\n" +
																		"*Dimensions should be = 200 x 200 \n" +
																		"*Only .png image is allowed"}
																</ReactTooltip>
															</div>
														</div>
													</Col>
													<Col
														md={3}
														lg={4}
														className="mt-2"
													>
														{attachedFileName ? (
															<Row
																style={{
																	marginLeft:
																		"10px",
																}}
															>
																<ImagePreviewer
																	src={`${Config.server_url}/${attachedFileName}`}
																/>
																<Input
																	name="attachment"
																	id="attachment"
																	type="file"
																	className="d-none"
																	readOnly={
																		true
																	}
																/>
																<Col className="d-flex flex-direction-row align-items-center">
																	<FontAwesomeIcon
																		icon={
																			faPaperclip
																		}
																		size="1x"
																		color="black"
																		className="attIcon"
																	/>
																	<a
																		href={`${Config.server_url}/${attachedFileName}`}
																		target="_blank"
																		rel="noopener noreferrer"
																		id="attLink"
																		className="link"
																	>
																		{attachedFileName.substring(
																			19,
																			30
																		)}
																	</a>
																	<span
																		onClick={() =>
																			document
																				.getElementById(
																					"attachedFile"
																				)
																				.click()
																		}
																	/>
																</Col>
																<Col className="d-flex align-items-center justify-content-end mx-0">
																	<FontAwesomeIcon
																		icon={
																			faWindowClose
																		}
																		className="att-remove-icon"
																		color="keppel"
																		onClick={() =>
																			handleRemoveAttachement()
																		}
																		hidden={
																			!attachment
																		}
																	/>
																</Col>
															</Row>
														) : (
															<Col className="d-flex flex-direction-row px-0 align-items-center">
																<ImagePreviewer
																	src={
																		attachment
																	}
																/>
																<Input
																	type="file"
																	name="attachment"
																	id="attachment"
																	accept="image/png"
																	onChange={(
																		value
																	) =>
																		handleAddAttachement(
																			value
																		)
																	}
																	style={{
																		marginLeft:
																			"20px",
																	}}
																	className="overflow-hidden"
																/>

																<span>
																	<FontAwesomeIcon
																		icon={
																			faWindowClose
																		}
																		className="att-remove-icon"
																		color="keppel"
																		onClick={() =>
																			handleRemoveAttachement()
																		}
																		hidden={
																			!attachment
																		}
																	/>
																</span>
															</Col>
														)}
														
	{/* ✅ Add the checkbox below image upload */}
	<div className="d-flex align-items-center mt-2">
		<Input
			type="checkbox"
			id="showOnAttendance"
			name="showOnAttendance"
			checked={employeeInfo.showOnAttendance || false}
			onChange={(e) =>
				handleChange(e.target.checked, 3, e)
			}
			className="mr-2"
		/>
		<Label for="showOnAttendance" className="mb-0">
			Show on Attendance Screen
		</Label>
	</div>
														{fileErr && (
															<div className="input-feedback">
																Only ".png" type
																files allowed
															</div>
														)}
														{fileSizeErr && (
															<div className="input-feedback">
																Image Size
																should be less
																than 1 MB
															</div>
														)}
													</Col>
												</Row>
											</Col>
										</div>
										{/*End of Employee Information Form*/}

										{/* Emergency Contact Form*/}
										<div className="formInfoContainer">
											<div className="formInfoContainerHeader">
												<Label sm={12}>
													Emergency Contact
												</Label>
											</div>
											<Col>
												<Row className="py-2 px-2">
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Person Name
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="empEmerContactName"
															value={
																employeeInfo.empEmerContactName
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>Phone 1</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="empEmerContactPhone1"
															value={employeeInfo.empEmerContactPhone1?.replace(
																/[^0-9+]/gi,
																""
															)}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>Phone 2</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="text"
															name="empEmerContactPhone2"
															value={employeeInfo.empEmerContactPhone2?.replace(
																/[^0-9+]/gi,
																""
															)}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>Address</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="textarea"
															maxLength="400"
															name="empEmerContactAdd"
															value={
																employeeInfo.empEmerContactAdd
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
												</Row>
											</Col>
										</div>
										{/* End of Emergency Contact Form*/}

										{/* Leave Balance Form*/}
										<div className="formInfoContainer mt-3">
											<div className="formInfoContainerHeader">
												<Label sm={12}>
													Leave Balance
												</Label>
											</div>
											<Col>
												<Row className="py-2 px-2">
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Annual Leaves
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="number"
															name="annualLeave"
															value={
																employeeInfo.annualLeave
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
													<Col md={3} lg={2}>
														<div className="formDetailHeader">
															<div>
																Sick Leaves
															</div>
														</div>
													</Col>
													<Col md={3} lg={4}>
														<Input
															type="number"
															name="sickLeave"
															value={
																employeeInfo.sickLeave
															}
															onChange={(
																value,
																event
															) =>
																handleChange(
																	value,
																	3,
																	event
																)
															}
															className={`supDesciptionBox`}
														/>
													</Col>
												</Row>
											</Col>
										</div>
										{/* End of Leave Balance Form*/}

										{/* Buttons Container*/}
										<div className="btns">
											<Button
												type="submit "
												className="submit-report leftBtn"
												onClick={handleSubmit}
											>
												Add
											</Button>

											<Button
												className="export-to-excel"
												onClick={handleReset}
											>
												Reset
											</Button>
										</div>
										{/*End of Buttons Container*/}
									</>
								</form>
							)}
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //Redirect to Dashboard for UnAuthorized User
				);
			}}
		</UserConsumer>
	);
}

export default AddEmployee;
